module.exports = __webpack_public_path__ + "static/img/588ku_37d4385e6004e6e11df58a5c1a294b4a_266793@2x.44ee3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/588ku_37d4385e6004e6e11df58a5c1a294b4a_266793@2x.png
// module id = p0W6
// module chunks = 1